import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../../../auth/service/utils.service';
import { AbsencesService } from '../../../../auth/service/absences.service';
import moment from 'moment';

@Component({
  selector: 'app-absences-to-work',
  templateUrl: './absences-to-work.component.html',
  styleUrls: ['./absences-to-work.component.scss'],
})
export class AbsencesToWorkComponent implements OnInit {
  public absences: any = [];


  constructor(
    public _absenceService: AbsencesService,
    public _utilService: UtilsService,
  ) {


  }

  async ngOnInit() {
    this.absences = await this._absenceService.getAbsencesList();
    this.absences = this.absences.filter(absence => absence.status === 0);
    this.absences = this.absences.sort((a, b) => moment(a.from) > moment(b.from) ? 1 : -1);
    this.absences = this.absences.slice(0, 5);
  }
}
